import { Stack } from "@mui/material";

type TransientJobConfigValueProps = {
  label: string;
  value: string;
};

export const TransientJobConfigValue = ({ label, value }: TransientJobConfigValueProps) => {
  return (
    <Stack className="w-full justify-between gap-2">
      <span className="text-lds-foreground-primary font-ds-body-semibold-sm">{label}</span>
      <span className="w-[20rem] text-left text-lds-foreground-primary font-ds-body-regular-md">{value}</span>
    </Stack>
  );
};
